import React from 'react';
import { useDispatch } from 'react-redux';

import { projectsReducer } from '../../store/reducers/projects.reducer.ts';

interface DeleteModalProps {
  isOpen: boolean;
  selectedItemId: number;
  selectedItemName: string;
  selectedItemType: string;
  onClose: () => void;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  isOpen,
  selectedItemId,
  selectedItemName,
  selectedItemType,
  onClose,
}) => {
  const dispatch = useDispatch();
  const { deleteProject, deleteFolder } = projectsReducer.actions;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!selectedItemId) {
      return;
    }

    if (selectedItemType === 'project') {
      dispatch(deleteProject(selectedItemId));
    } else if (selectedItemType === 'folder') {
      dispatch(deleteFolder(selectedItemId));
    }

    onClose();
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Escape') {
      event.stopPropagation();
      onClose();
    }
  };

  const handleCancel = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center"
        onClick={handleCancel}
        onKeyDown={handleKeyDown}
      >
        <div className="bg-greyP5 rounded-md shadow-xl w-[602px] h-auto p-10" onClick={(e) => e.stopPropagation()}>
          <div className="flex items-center justify-between pb-2 border-b border-greyP4">
            <div className="flex items-center space-x-3">
              <h2 className="text-white text-lg font-medium">Delete {selectedItemType}</h2>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="pt-8 space-y-6">
            <div className="flex flex-col space-y-2">
              <p>
                Are you sure you want to delete the {selectedItemType} <strong>"{selectedItemName}"</strong>?
              </p>
              <p>This action cannot be undone.</p>
            </div>

            <div className="flex items-center justify-end space-x-4 pt-4">
              <button
                type="button"
                onClick={handleCancel}
                className="px-6 py-2 hover:text-gray-400 text-white border border-white rounded-3xl hover:border-gray-500 transition-colors duration-200"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-6 py-2 bg-white text-black font-medium rounded-3xl hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
              >
                Delete
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default DeleteModal;
